export default "__VITE_ASSET__Arpnb_WL__"